// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const deleteInvoicePathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  id: z.number().int().describe("Invoice ID"),
});

export const deleteInvoiceHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Invoice deleted
 */
export const deleteInvoice200Schema = z.object({});

/**
 * @description Unauthorized
 */
export const deleteInvoice401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const deleteInvoiceMutationResponseSchema = z.lazy(() => deleteInvoice200Schema);
